/** Inline autocomplete search mark type */
export const INLINE_AUTOCOMPLETE_SEARCH = 'inline-autocomplete-search';
